import React from 'react';
import {Tabs} from 'antd'
import 'antd/lib/tabs/style/css';
import './tablhelpers.css';

const TabsHelper = (props) => {
  return (
      <Tabs type="card">
        {[...Array(props.number)].map((x, i) => {
          let Content = props.content[i];
          return <Tabs.TabPane tab={props.titles[i]} key={props.keys[i]}><Content {...props.tabProps[i]}/></Tabs.TabPane>;
        })}
      </Tabs>
  );
};


export default TabsHelper;